const theme = {
  // Neutral colors
  white: '#FFFFFF',
  black: '#000000',
  red: '#FF0000',
  success: '#16A34A',
  warning: '#ca3b3b',
  neutralGray: {
    100: '#F5F5F5',
    200: '#EAEAEA',
    300: '#CCCCCC',
    400: '#999999',
    500: '#555555',
    600: '#222222',
  },
  main: {
    100: '#F1FCFD',
    200: '#c3eaea',
    300: '#a3dfe0',
    400: '#80d4d5',
    500: '#57c9cb',
    600: '#00bec1',
  },

  // Main theme colors
  primary: '#00BEC1',
  excel: '#217346',
  secondary: {
    100: '#eff5f5',
    200: '#dfebec',
    300: '#bfd7d9',
    400: '#9fc4c6',
    500: '#7eb0b3',
    600: '#5f9da0',
  },
  background: '#F6F9FA',

  // Main gradation colors
  mainGradationStart: '#00BEC1',
  mainGradationEnd: '#00d7db',

  // Colors for components
  indigo: '#0F2A4A',
  lightIndigo: '#35557C',

  skyGray: '#EDF4F5',
  darkNavy: '#0F2A4A',

  wall: '#CCCCCC',
  seatLevel: '#0F2A4A',
  seatBackground: '#555555',
  normalSeat: 'white',
  occupiedSeat: '#35557C',
  fixedSeat: '#CCE2FF',
  unavailableSeat: '#CCCCCC',
  seminarSeat: '#C4BCE8',
  idleSeat: 'transparent',
  normalSeatWithDisposableTicket: '#999999',
  normalSeatWithPeriodicTicket: '#E68E21',
  normalSeatWithTimeBasedTicket: '#02838F',
  normalSeatWithLockerTicket: '#555555',
  fixedSeatWithPeriodicTicket: '#1968C9',

  normalSeatWithDisposableTicketRest: '#cccccc',
  normalSeatWithPeriodicTicketRest: '#f5d2a6',
  normalSeatWithTimeBasedTicketRest: '#9acdd2',
  fixedSeatWithPeriodicTicketRest: '#a2c3e9',

  mainFeatureButton: '#EBF3FC',

  // Colors with alpha channel
  whiteAlpha: {
    900: '#FFFFFFE5',
  },
  darkNavyAlpha: {
    800: '#0F2A4ACC',
  },

  // ── Design tokens (LETMEUP-515) ──
  spacing: { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: '24px', xxl: '32px', xxxl: '48px' },
  radius: { sm: '8px', md: '12px', lg: '16px', xl: '24px', full: '9999px' },
  shadow: {
    sm: '0 1px 2px rgba(15,42,74,0.06)',
    md: '0 4px 16px rgba(15,42,74,0.08)',
    lg: '0 8px 32px rgba(15,42,74,0.12)',
  },
  typography: {
    h1: { size: '24px', lineHeight: '32px', weight: 700 },
    h2: { size: '20px', lineHeight: '28px', weight: 700 },
    h3: { size: '16px', lineHeight: '24px', weight: 600 },
    body: { size: '15px', lineHeight: '22px', weight: 400 },
    bodySm: { size: '13px', lineHeight: '18px', weight: 400 },
    caption: { size: '12px', lineHeight: '16px', weight: 400 },
  },
  control: { height: '54px', heightSm: '44px', minTapTarget: '44px', fontSize: '16px' },
  danger: '#E5484D',
  info: '#0F2A4A',
};

export default theme;
